import React, { useRef, useState } from 'react';
import { loadable } from 'react-lazily/loadable';
import { lazily } from 'react-lazily';
import { useSelector, shallowEqual } from 'react-redux';
import { RootReducerState } from 'reduxStore/rootReducers';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose, AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import Button from 'components/buttons/Button';
import { storage, ROAD_BLOCK_MODAL } from 'utils/global';
const { ReactCarouselSlider } = loadable(() => import('components'));
const { TranslationMessage } = loadable(() => import('components'));

interface Props {}

const RoadBlock = (props: Props) => {
	// roadblock modal
	const [show, setShow] = useState<any>(storage.getSession(ROAD_BLOCK_MODAL) ? false : true);

	let sliderRef: any = useRef<any>();
	const roadblocksettings = {
		dots: false,
		arrows: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 4000,
		// variableWidth: true
	};

	const { roadBlockData } = useSelector(
		({ roadBlockReducer }: RootReducerState) => ({
			error: roadBlockReducer.error,
			loading: roadBlockReducer.loading,
			roadBlockData: roadBlockReducer.data,
		}),
		shallowEqual
	);

	const handleClose = () => {
		setShow(false);
		storage.setSession(ROAD_BLOCK_MODAL, false);
	};

	const gotoNext = () => {
		sliderRef.current.slickNext();
	};
	const gotoPrevious = () => {
		sliderRef.current.slickPrev();
	};

	return roadBlockData?.length > 0 && window.location.pathname != '/individual/support-individual/terms-conditions' ? (
		<Modal className="roadblock-modal" backdrop="static" show={show} onHide={() => setShow(false)} size="lg" aria-labelledby="example-custom-modal-styling-title" centered>
			<Button className="modalHeaderClose" onClick={handleClose}>
				<AiOutlineClose />
			</Button>

			{roadBlockData?.length > 1 && (
				<React.Fragment>
					<div className="btn modalArrow modalArrow-left" onClick={gotoPrevious}>
						<AiOutlineLeft />
					</div>
					<div className="btn modalArrow modalArrow-right" onClick={gotoNext}>
						<AiOutlineRight />
					</div>
				</React.Fragment>
			)}

			<Modal.Body className="text-center">
				{roadBlockData?.map((item, index) => (
					<div key={index} className="h-100">
						<TranslationMessage data={item} value="description" isHtmlParse />
					</div>
				))}
				{/* <img
							className="image-banner-img "
							src="https://picsum.photos/2100/850?img=1"
							alt="banner"
						/>
						<img
							className="image-banner-img "
							src="https://picsum.photos/1500/850?img=1"
							alt="banner"
						/> */}

				{/* </div> */}
			</Modal.Body>
		</Modal>
	) : null;
};

export default RoadBlock;
